import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';
// import { ISlimScrollOptions } from 'ng2-slimscroll';
//import 'rxjs/add/operator/map';

import { CONSTANT_VALUES } from '../../../constants/constant-values';
import { AppService } from '../../../app.service';
import { MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SetAllMemberCheck } from './../../../shared/message.event';
import { FeedService } from './../../feed.service';
import { CONSTANT_MESSAGES } from '../../../constants/constants-messages';
import { UISETTING } from './../../../shared/ui-setting';
import { UtilityFunctions } from './../../../shared/utility-functions';
@Component({
    selector: 'app-broadcast',
    templateUrl: './broadcast.component.html',
    styleUrls: ['./broadcast.component.css'],
    providers: [MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, FeedService, SetAllMemberCheck]
})
export class BroadcastComponent implements OnInit {
    private shouldSlide: boolean = false;
    private divHeight = 30;
    private pagebutton = 30;
    private vendor;
    private clubName = '';
    private groupList = [];
    private category = 'BROADCAST';
    private categoryList = CONSTANT_VALUES.CATEGORY_LIST_FOR_FEED;
    private createdAt;
    private feed: any;
    filesToUpload: any;
    private popUpMessage;
    private fileUrl;
    private criteria;
    //private scrollOptions: ISlimScrollOptions;
    private onePagePerItem = 10; // It will set by vendor configuration object
    private pageOptions = {
        currentPage: 1,
        noOfPageItem: this.onePagePerItem
    };
    private currentPage = 1;
    private memberList = [];
    private totalSizeOfList = 0;
    private noMemberAvailable: boolean = true;
    @ViewChild('memberTable')
    tableVariable: any;
    private setChecked = [];
    private isopen = false;
    private selectedCriteria = '';
    private ideal = true;
    private selectedMemberList = [];
    private selectedGroupList = [];
    private memberTableHeight = 55;
    private alertMessage = '';
    private broadcastToList = CONSTANT_VALUES.BROADCAST_SEND_TO;
    @ViewChild('fileUploadInput')
    fileUploadInputVariable: any;
    private AddNewMemberFlag = false;
    private cancelForReset = false;
    private addGroupFlagCancel = false;
    private search = '';
    private exp = false;
    private selectNewMembers = [];
    private uiSetting: UISETTING;
    private height: any;
    private utilityFunctions = new UtilityFunctions();
    private urlErr = '';
    constructor(private router: Router, private appService: AppService,
        private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private facilityListEvent: FacilityListEvent,
        private openFrameEvent: OpenFrameEvent, private feedService: FeedService, private setAllMemberCheck: SetAllMemberCheck) {
        this.uiSetting = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 35
        }
        this.height = 0;
        this.feed = {
            title: '',
            content: '',
            vendorId: '',
            groups: [],
            members: [],
            sendToAllMembers: false,
            file: '',
            sendOn: '',
            sendToAllGroups: false,
            broadcastLink: ''
        }
        this.criteria = {
            allMember: false,
            specificMembers: false,
            allGroup: false,
            specificGroup: false
        };
        // this.scrollOptions = {
        //    barBackground: "#343a40", barOpacity: "0.6", position: "right",
        //    barWidth: "6", barBorderRadius: "5",barMargin:"1px 1px",gridBackground:"#adb5bd",gridOpacity:"1",gridWidth:"4",gridBorderRadius:"10",gridMargin:"1px 2px"
        // };
        this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.divHeight + this.pagebutton)) + 'px';
    }

    ngOnInit() {
        this.emitOpenFrameEvent();
        window.scrollTo(0, 0);
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.clubName = subVendor.clubName;
            }
        } else {
            this.clubName = this.vendor.clubName;
        }
        this.createdAt = moment(new Date()).format('dddd, MMM DD, YYYY');
        this.getGroupListByVendor();
        this.pagination(this.pageOptions, 1);
        this.getGroupListByVendor();
        this.registerTypeBroadcast();
        this.emitTypeBroadcast();
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster  
     */

    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(message => {
                this.shouldSlide = message;
            });
    }

    /**
     * function show menu at facility page by broadcaster
     */

    emitTypeBroadcast() {
        this.signInEvent.fire('block');
    }

    emitTypeLoaderBroadcast() {
        this.loaderEvent.fire(false);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }
    /**
     * Get group list created by specific vendor
     * 
     * 
     * @memberOf BroadcastComponent
     */
    getGroupListByVendor() {
        let vendorObj = {
            vendorId: this.vendor._id
        }
        this.appService.getListOfGroup(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.groupList = result.groups;
            } else {
            }
        });
    }
    /**
     * Select category to compose message
     * 
     * @param {any} para 
     * 
     * @memberOf BroadcastComponent
     */
    selectCategory(para) {
        this.category = para;
        let that = this;
        setTimeout(function () {
            if (para === 'ALERT') {
                that.router.navigate(['/alert']);
            }
        }, 100);

    }
    /**
     * Select image for broadcast
     * 
     * @param {any} event 
     * @param {any} alertImagePopUpObj 
     * 
     * @memberOf BroadcastComponent
     */
    uploadFile(event, alertImagePopUpObj) {
        this.loaderEvent.fire(false);
        this.fileUrl = event.target.files[0];
        let input = event.target;
        let file = input.files[0];
        let that = this;
        let reader = new FileReader();
        if (file) {
            if (file.name.indexOf('.jpg') > 0 || file.name.indexOf('.png') > 0 || file.name.indexOf('.bmp') > 0
                || file.name.indexOf('.jpeg') > 0 || file.name.indexOf('.tiff') > 0) {
                this.readFile(file, reader, (result) => {
                    that.filesToUpload = result;
                    that.loaderEvent.fire(true);
                });
            } else {
                that.loaderEvent.fire(true);
                that.alertMessage = CONSTANT_MESSAGES.IMAGE_ERROR;
                alertImagePopUpObj.showChildModal();
            }
        } else {
            this.loaderEvent.fire(true);
        }
    }

    readFile(file, reader, callback) {
        reader.onload = () => {
            callback(reader.result);
        };
        reader.readAsDataURL(file);
    }
    /**
     * Send feed to specific or all members or groups
     * 
     * @param {any} popupObj 
     * @param {any} backPopUpObj 
     * 
     * @memberOf BroadcastComponent
     */
    sendFeed(popupObj, backPopUpObj) {
        try {
            let that = this;
            let form_data = new FormData();
            if (this.validateFeed(popupObj)) {
                this.selectedGroupList = this.selectedGroupList.filter(function (rec: any) {
                    that.feed.groups.push(rec._id);
                    return rec;
                });
                this.selectedMemberList = this.selectedMemberList.filter(function (rec: any) {
                    that.feed.members.push(rec.userId);
                    return rec;
                });
                form_data.append('title', this.feed.title);
                form_data.append('content', this.feed.content);
                form_data.append('type', this.category);
                form_data.append('vendorId', this.vendor._id);
                form_data.append('groups', this.feed.groups.toString());
                form_data.append('sendOn', new Date().toISOString());
                form_data.append('sendToAllMembers', (this.feed.sendToAllMembers).toString());
                form_data.append('members', this.feed.members.toString());
                form_data.append('file', this.fileUrl);


                form_data.append('sendToAllGroups', (this.feed.sendToAllGroups).toString());
                form_data.append('broadcastLink', (this.feed.broadcastLink).toString());
                form_data.append('systemUserId', (this.vendor._id));
                form_data.append('token', (this.vendor.token));
                let appVersion = localStorage.getItem('appVersion')
                if (appVersion) {
                    form_data.append('appVersion', (appVersion).toString());
                }
                form_data.append('deviceType', (CONSTANT_VALUES.DEVICE_TYPE).toString());
                this.feedService.sendFeed(form_data).then((result: any) => {
                    if (result.status === 'SUCCESS') {
                    } else {
                    }
                    this.popUpMessage = result.message;
                    backPopUpObj.showChildModal();
                });
            }
        } catch (e) {

        }
    }
    /**
     * Validate feed details
     * 
     * @param {any} popupObj 
     * @returns 
     * 
     * @memberOf BroadcastComponent
     */
    validateFeed(popupObj) {
        try {
            let validateFLag = true;
            if (!(this.feed.title + '').trim()) {
                validateFLag = false;
                this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_SUBJECT;
                popupObj.showChildModal();
                return validateFLag;
            } else if (!(this.feed.content + '').trim()) {
                validateFLag = false;
                this.popUpMessage = CONSTANT_MESSAGES.ERROR_MESSAGE_CONTENT;
                popupObj.showChildModal();
                return validateFLag;
            } else if (this.checkUrl()) {
                validateFLag = false;
                this.popUpMessage = CONSTANT_MESSAGES.INVALID_URL;
                popupObj.showChildModal();
            } else if ((this.selectedGroupList.length === 0) && !this.feed.sendToAllGroups && !this.feed.sendToAllMembers && (this.selectedMemberList.length === 0)) {
                validateFLag = false;
                this.popUpMessage = CONSTANT_MESSAGES.SELECT_RECIPIENTS_BROADCAST;
                popupObj.showChildModal();
                return validateFLag;
            }
            return validateFLag;
        } catch (e) {
            console.log(e);
        }
    }

    goToFeed(bool: boolean) {
        this.feedService.goToFeed(this);
    }
    /**
     * Get different scenarios for recipients. 
     * 
     * @param {any} para 
     * @param {any} popupObj 
     * 
     * @memberOf BroadcastComponent
     */
    actionOnCriteria(para, popupObj) {
        if (this.selectedCriteria !== para) {
            this.selectedCriteria = para;
            this.criteria.allMember = false;
            this.criteria.allMember = false;
            this.criteria.specificMembers = false;
            switch (para) {
                case 'All Members':
                    if (this.memberList.length === 0) {
                        this.selectedCriteria = '';
                        this.popUpMessage = CONSTANT_MESSAGES.NO_MEMBER_AVAILABLE;
                        popupObj.showChildModal();
                    } else {
                        this.selectedMemberList = [];
                        this.setChecked = [];
                        this.unSelectSpecificGroup();
                        this.criteria.allMember = true;
                        this.feed.sendToAllMembers = true;
                    }
                    break;
                case 'Specific Members':
                    if (this.memberList.length > 0) {
                        this.unSelectSpecificGroup();
                        this.feed.sendToAllMembers = false;
                        this.criteria.specificMembers = true;
                        this.ideal = false;
                        this.cancelForReset = true;
                        this.pagination(this.pageOptions, 1);
                    } else {
                        this.selectedCriteria = '';
                        this.popUpMessage = CONSTANT_MESSAGES.NO_MEMBER_AVAILABLE;
                        popupObj.showChildModal();
                    }
                    break;
                case 'All Groups':
                    if (this.groupList.length === 0) {
                        this.selectedCriteria = '';
                        this.popUpMessage = CONSTANT_MESSAGES.NO_GROUP_AVAILABLE;
                        popupObj.showChildModal();
                    } else {
                        this.unSelectSpecificMembers();
                        this.feed.groups = [];
                        this.selectedGroupList = [];
                        this.criteria.allGroup = true;
                        this.feed.sendToAllGroups = true;
                    }
                    break;
                case 'Specific Groups':
                    if (this.groupList.length > 0) {
                        this.unSelectSpecificMembers();
                        this.cancelForReset = true;
                        this.criteria.specificGroup = true;
                        this.ideal = false;
                    } else {
                        this.selectedCriteria = '';
                        this.popUpMessage = CONSTANT_MESSAGES.NO_GROUP_AVAILABLE;
                        popupObj.showChildModal();
                    }
                    break;
            }
        }
        this.isopen = false;
    }
    /**
     * Pagination if number of members is too large
     * 
     * @param {any} pageOptions 
     * @param {any} pageNo 
     * 
     * @memberOf BroadcastComponent
     */
    pagination(pageOptions, pageNo) {
        this.currentPage = 1;
        if (pageOptions) {
            this.pageOptions = pageOptions;
        }

        let vendorObject = {
            'vendorId': this.vendor._id,
            perPage: this.pageOptions.noOfPageItem,
            pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
            filters: []
        };
        if (this.AddNewMemberFlag) {
            vendorObject.filters = [{
                type: 'exclude',
                values: this.setChecked
            }];
        }
        if ((this.search + '').trim()) {
            vendorObject['filters'].push({
                type: 'search',
                values: this.search
            });
            this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
        }
        this.getMemberListByVendor(vendorObject);
    }
    /**
     * Get member list by vendor
     * 
     * @param {any} vendorObj 
     * 
     * @memberOf BroadcastComponent
     */
    getMemberListByVendor(vendorObj) {
        try {
            this.loaderEvent.fire(false);
            let that;
            this.appService.getListOfMember(vendorObj).then((result: any) => {
                if (result.status === 'SUCCESS') {
                    this.memberList = result.memberList;
                    this.totalSizeOfList = result.total;
                    this.noMemberAvailable = (result.total > 0);
                    this.memberList.map(function (mem) {
                        if (!mem.isBlackListed) {
                            mem.enable = 'Active';
                        } else {
                            mem.enable = 'Inactive';
                        }
                        mem.signedUpOn = moment(mem.signedUpOn).format('DD/MM/YYYY');
                        return mem;
                    });
                }
                this.setCheckedList();
                that = this;
                if (this.selectedMemberList.length > 0) {
                    this.memberList = this.memberList.filter(function (rec: any) {
                        if (_.some(that.selectedMemberList, rec)) {
                            rec.isChecked = true;
                        }
                        return rec;
                    });
                    this.setAllMemberCheck.fire(true);
                }
                this.loaderEvent.fire(true);
            }).catch((err) => {
                this.popUpMessage = err;
                this.loaderEvent.fire(true);
            });

        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Select specific member with check box selection
     * 
     * @param {*} memberObj 
     * 
     * @memberOf BroadcastComponent
     */
    selectSpecificMembers(memberObj: any) {
        try {
            if (memberObj.isChecked) {
                this.selectedMemberList.push(memberObj);
                this.selectNewMembers.push(memberObj);
            } else {
                _.remove(this.selectedMemberList, function (n) {
                    return n.userId === memberObj.userId;
                });
                _.remove(this.selectNewMembers, function (n) {
                    return n.userId === memberObj.userId;
                });
                if (this.tableVariable.allInGroup) {
                    this.tableVariable.allInGroup = false;
                }
            }
            this.selectedMemberList = _.uniq(this.selectedMemberList);
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Select all members on single page
     * 
     * @param {*} memberList 
     * 
     * @memberOf BroadcastComponent
     */
    selectAllMembers(memberList: any) {
        try {
            let that = this;
            this.setUserIdListTOSendFeed();
            if (!this.tableVariable.allInGroup) {
                for (let rec of this.memberList) {
                    _.remove(that.selectedMemberList, function (n) {
                        return n.isChecked === false;
                    });
                    _.remove(that.selectNewMembers, function (n) {
                        return n.isChecked === false;
                    });
                }
            } else {
            }
        } catch (e) {
            console.log(e);
        }
    }

    setUserIdListTOSendFeed() {
        for (let mem of this.memberList) {
            if ((this.selectedMemberList.indexOf(mem) < 0)) {
                this.selectedMemberList.push(mem);
            }
            if ((this.selectNewMembers.indexOf(mem) < 0)) {
                this.selectNewMembers.push(mem);
            }
        }
        this.selectedMemberList = _.uniq(this.selectedMemberList);
        this.selectNewMembers = _.uniq(this.selectNewMembers);
    }
    /**
     * Reset page
     * 
     * 
     * @memberOf BroadcastComponent
     */
    reset() {
        try {
            this.setFlagOnReset();
            this.exp = false;
            this.search = '';
            if (this.tableVariable) {
                this.tableVariable.allInGroup = false;
            }
            this.unSelectSpecificGroup();
            this.selectedCriteria = '';
            this.criteria.specificGroup = false;
            this.unSelectSpecificMembers();
            this.groupList.map(function (rec: any) {
                if (rec.checked === true) {
                    rec.checked = false;
                }
                return;
            });
            this.selectNewMembers = [];
            this.pagination(this.pageOptions, 1);
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Go to compose message page and reset required values
     * 
     * @param {any} popUpObj 
     * 
     * @memberOf BroadcastComponent
     */
    goToComposeMessage(popUpObj) {
        if (this.checkMemberListForSelection()) {
            this.tableVariable.allInGroup = false;
            this.setFlagOnReset();
            this.AddNewMemberFlag = false;
        } else {
            this.popUpMessage = CONSTANT_MESSAGES.SELECT_MEMBER_FEED;
            popUpObj.showChildModal();
        }
        this.selectedMemberList = _.uniq(this.selectedMemberList);
    }
    /**
     * Show popup containing recipients
     * 
     * @param {any} popupObj 
     * @param {any} popupForMember 
     * @param {any} ViewSelectedGroupPopUpObj 
     * 
     * @memberOf BroadcastComponent
     */
    showSelectedItems(popupObj, popupForMember, ViewSelectedGroupPopUpObj) {
        switch (this.selectedCriteria) {
            case 'Specific Members':
                if (this.selectedMemberList.length > 0) {
                    popupForMember.showChildModal();
                } else {
                    this.popUpMessage = 'There no selected recipients.'
                }
                break;
            case 'Specific Groups':
                ViewSelectedGroupPopUpObj.showChildModal();
                break;
        }
    }

    /**
 * Store selected group list
 * 
 * @param {any} popupObj 
 * @param {any} popupForMember 
 * @param {any} ViewSelectedGroupPopUpObj 
 * 
 * @memberOf BroadcastComponent
 */
    saveGroupList(popupObj) {
        let flag = false;
        for (let group of this.groupList) {
            if (group.checked) {
                if (!_.some(this.selectedGroupList, group)) {
                    this.selectedGroupList.push(group);
                }
            } else {
                if (_.some(this.selectedGroupList, group)) {
                    _.remove(this.selectedGroupList, function (n) {
                        return n._id === group._id;
                    });
                }
            }
        }
        for (let group of this.groupList) {
            if (group.checked) {
                flag = true;
                break;
            }
        }
        this.selectedGroupList = _.uniq(this.selectedGroupList);
        if (!flag) {
            this.popUpMessage = CONSTANT_MESSAGES.SELECT_Group_FEED;
            popupObj.showChildModal();
        } else {
            this.criteria.specificGroup = false;
            this.cancelForReset = false;
            this.ideal = true;
            this.AddNewMemberFlag = false;
            this.addGroupFlagCancel = false;
        }
    }
    /**
     * Store selected member list against pagination
     * 
     * 
     * @memberOf BroadcastComponent
     */
    setCheckedList() {
        try {
            let flagAllChecked = true;
            for (let mem of this.memberList) {
                if (!mem.isChecked) {
                    flagAllChecked = false;
                    break;
                }
            }
            if (this.tableVariable) {
                if (flagAllChecked) {
                    this.tableVariable.allInGroup = true;
                } else {
                    this.tableVariable.allInGroup = false;
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Remove image
     * 
     * 
     * @memberOf BroadcastComponent
     */
    removeImage() {
        this.filesToUpload = '';
        this.feed.file = '';
        this.fileUploadInputVariable.nativeElement.value = '';
    }
    /**
     * Add specific members or recipients
     * 
     * 
     * @memberOf BroadcastComponent
     */
    addRecipants() {
        this.exp = false;
        this.search = '';
        this.selectedMemberList = _.uniq(this.selectedMemberList);
        let that = this;
        this.ideal = false;
        this.cancelForReset = false;
        switch (this.selectedCriteria) {
            case 'Specific Members':
                this.setChecked = [];
                this.selectNewMembers = [];
                for (let item of this.selectedMemberList) {
                    this.setChecked.push(item.userId);
                }
                this.criteria.specificMembers = true;
                this.addGroupFlagCancel = false;
                this.AddNewMemberFlag = true;
                this.pagination(this.pageOptions, 1);
                break;
            case 'Specific Groups':
                this.ideal = false;
                this.addGroupFlagCancel = true;
                this.cancelForReset = false;
                this.AddNewMemberFlag = false;
                this.criteria.specificGroup = true;
                this.groupList = this.groupList.filter(function (rec: any) {
                    if (!_.some(that.selectedGroupList, rec)) {
                        return rec;
                    }
                });
                break;
        }
    }
    /**
     * Remove selected members from list 
     * 
     * @param {any} member 
     * 
     * @memberOf BroadcastComponent
     */
    removeFromSelection(member) {

        for (let item of this.selectedMemberList) {
            if (item.userId === member.userId) {
                _.remove(this.selectedMemberList, function (n) {
                    return n.userId === member.userId;
                });
                break;
            }
        }
        if (this.selectedMemberList.length === 0) {
            this.selectedCriteria = '';
        }
    }
    /**
     * Remove selected group from list
     * 
     * @param {any} group 
     * 
     * @memberOf BroadcastComponent
     */
    removeGroupFromSelection(group) {
        if (_.some(this.selectedGroupList, group)) {
            _.remove(this.selectedGroupList, function (n) {
                return n._id === group._id;
            });
        }
        if (this.selectedGroupList.length === 0) {
            this.selectedCriteria = '';
        }
        this.getGroupListByVendor();
    }
    /**
     *  Reset member list after cancel click
     * @memberOf BroadcastComponent
     */
    removeMemberList() {
        this.criteria.specificMembers = false;
        let that = this;
        for (let member of this.memberList) {
            for (let item of this.selectedMemberList) {
                if (member.userId === item.userId) {
                    member.isChecked = true;
                } else {
                    member.isChecked = false;
                }
                break;
            }
        }
        this.AddNewMemberFlag = false;
    }
    /**
     * Reset group selection on cancel
     * @memberOf BroadcastComponent
     */
    removeGroupFromSelectionOnCancel() {
        this.AddNewMemberFlag = false;
        this.addGroupFlagCancel = false;
        this.cancelForReset = false;
        this.ideal = true;
    }

    checkMemberListForSelection() {
        return this.selectNewMembers.some(item => {
            return item.isChecked;
        });
    }
    /**
     * Expand input text for search
     * 
     * 
     * @memberOf BroadcastComponent
     */
    expand() {
        if (!this.search) {
            this.exp = !this.exp;
        }

        if (this.selectedCriteria == 'Specific Members') {
            this.pagination(this.pageOptions, 1);
        }
    }
    /**
     * Set flag for view changes
     */
    setFlagOnReset() {
        this.criteria.specificMembers = false;
        this.isopen = false;
        this.ideal = true;
        this.cancelForReset = false;
    }

    unSelectSpecificMembers() {
        this.feed.sendToAllMembers = false;
        this.selectedMemberList = [];
        this.setChecked = [];
    }

    unSelectSpecificGroup() {
        this.feed.sendToAllGroups = false;
        this.feed.groups = [];
        this.selectedGroupList = [];
    }

    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }

    checkUrl() {
        let regEx = /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
        if (this.feed.broadcastLink) {
            if (!regEx.test(this.feed.broadcastLink)) {
                return true;
            } else {
                return false;
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/feed/compose-message/broadcast/broadcast.component.ts